import { addToStartOfChain } from "@insite/client-framework/HandlerCreator";
import { chain } from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";

addToStartOfChain(chain, props => {
    const {
        parameter: { carouselType, numberOfProductsToDisplay },
    } = props;
    if (carouselType !== "customerSpecificProducts") {
        return;
    }

    const existingParams = props.getProductCollectionParameter?.additionalQueryStringParameters ?? {};
    existingParams["customerSpecificProducts"] = "true";
    props.getProductCollectionParameter = { additionalQueryStringParameters: existingParams, pageSize: numberOfProductsToDisplay };
});